import React, { useState, useEffect } from 'react';

import './planes.scss';

import { BarraPasos } from './BarraPasos';
import icoParaMi from '../assets/img/ico-para-mi.svg';
import icoParaAlguien from '../assets/img/ico-para-alguien.svg';
import icoCasa from '../assets/img/ico-plan-en-casa.svg'
/*import icoHospital from '../assets/img/ico-plan-en-hospital.svg';*/
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import { Header } from './Header';
import { Footer } from './Footer';

export const Planes = () => {
    const [planes, setPlanes] = useState([]);
    const [mostrarPlanes, setMostrarPlanes] = useState(false);
    const [descuento, setDescuento] = useState(1);
    const [redireccionar, setRedireccionar] = useState(false);
    const [activoBoton1, setActivoBoton1] = useState(false);
    const [activoBoton2, setActivoBoton2] = useState(false);
    const [esOtro, setEsOtro] = useState(false);

  useEffect(() => {
    const fetchPlanes = async () => {
      try {
        const response = await axios.get('plans.json');
        setPlanes(response.data.list);
      } catch (error) {
        console.error('Error al cargar los planes:', error);
      }
    };

    fetchPlanes();
  }, []);

  const handleSeleccion = (tipo) => {
    
    if (tipo === 'mi') {
        setMostrarPlanes(true);
        setDescuento(1);
        setActivoBoton1(true);
        setActivoBoton2(false);
        setEsOtro(false);
    } else if (tipo === 'otro') {
        setMostrarPlanes(true);
        setDescuento(0.95);
        setActivoBoton1(false);
        setActivoBoton2(true);
        setEsOtro(true);
    }
  };

  const handleSeleccionPlan = (planId, planName, planPrice ) => {
    setRedireccionar(true);
    localStorage.setItem('planId', planId);
    localStorage.setItem('planName', planName);
    localStorage.setItem('planPrice', planPrice);
  };

  if (redireccionar) {
    return <Navigate to="/Resumen" />;
  }


  return (



    <div className="wrapper wrapper_interna">
        <Header />
        <section className="seccion_principal">
            <BarraPasos/>
            <section className="seccion_planes">
                <div className="container">	
					<h1>
                        Rocío ¿Para quién deseas cotizar?
                    </h1>
                    <div className="parrafo">
                        Selecciona la opción que se ajuste más a tus necesidades.
                    </div>			
                    
                    <div className="caja_opciones">
                        
                        <article className={activoBoton1 ? 'activo' : '' } onClick={() => handleSeleccion('mi')}>
                            <div className="check"></div>
                            <div className="c">
                                <div className="sup">
                                    <div className="ico">
                                        <img src={icoParaMi} alt="Para mi" />
                                            
                                    </div>
                                    <div className="tit">
                                        Para mí
                                    </div>
                                </div>
                                <div className="texto">
                                    Cotiza tu seguro de salud y agrega familiares si así lo deseas.
                                </div>
                            </div>
                            
                        </article>
                    
                        <article className={activoBoton2 ? 'activo' : '' } onClick={() => handleSeleccion('otro')}>
                            <div className="check"></div>
                            <div className="c">
                                <div className="sup">
                                    <div className="ico">
                                        <img src={icoParaAlguien} alt="Para alguien" />
                                    </div>
                                    <div className="tit">
                                        Para alguien más
                                    </div>
                                </div>
                                <div className="texto">
                                    Realiza una cotización para uno de tus familiares o cualquier persona.
                                </div>
                            </div>
                            
                        </article>
                            
                    </div>

                    {mostrarPlanes && (

                        <div className="caja_planes">
                            {planes.map((plan) => (
                                <article key={plan.id}>
                                    <div className="superior">
                                        <div className="nombre_del_plan">
                                            {plan.name}
                                        </div>
                                        <div className="txt_gris">
                                            COSTO DEL PLAN
                                        </div>
                                        {esOtro && <div className="precio_regular">${plan.price} antes </div>}
                                        <div className="precio">
                                            $<span>{plan.price * descuento}</span> al mes
                                        </div>
                                        <div className="ico">
                                            <img src={icoCasa} alt="Para mi" />
                                        </div>
                                    </div>
                                    <ul className="lista_detalle">
                                        {plan.description.map((description, idx) => (
                                            <li key={idx}>{description}</li>
                                        ))}
                                    </ul>

                                    <div className="btn_seleccionar_plan" onClick={() => handleSeleccionPlan(plan.id, plan.name, plan.price * descuento)}>
                                        Seleccionar Plan
                                    </div>
                                </article>
                             ))}
                        </div>
                     )}
			    </div>
            </section>	
        </section>
        <Footer/>
        <div>
           
            
            
                
           
        </div>
    </div>   
     
    
  )
}
